<template>
  <div>
    <ob-collapse :type="6" :expand.sync="expandTools">
      <h4 class="h4_design" style=" font-weight: 600; color:#475259;font-size:13.5px;" slot="collapse-title">
        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_link.svg`" style="padding-right:8px;"/>
            Linked Employees <span v-if="length > 0" class="circle">{{length}}</span>
      </h4>
      <div slot="collapse-details">
        <template>
          <div class="col-md-12" :class="{ 'linkedEmp_border' : length > 0}">
            <template v-for="(item,index) in LinkedEmpList">
              <div class="tools-view" v-if="item.Name != '' && item.Name != null" :key="index">
                <span>
                  {{item.Name}}
                </span>
                <!-- <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 3px;">
                  <span class="cross-mark" @click="confirmDelete(item.Id)" style="font-size: 11px; padding: 2px 5px;" >&#10006;</span>
                </span> -->
              </div>
            </template>
          </div>
        </template>
      </div>
    </ob-collapse>
  </div>
</template>

<script>
export default {
props: ["LinkedEmployeesList", "TaskId"],
  data() {
    return {
      expandTools:true,
      openInput:false,
      LinkedEmpList:[],
      }
    },
    components: {

    },
    watch: {
      LinkedEmployeesList(val)
      {
          this.LinkedEmpList = val
      }
    },
    computed: {
        CreatedBy() {
          return this.loggedInUserObj.Name;
        },
        length(){
            return this.LinkedEmpList && this.LinkedEmpList.length
        },
        currentEmpId(){
            return this.$route.query.empId
        }
    },
    created() {
       this.LinkedEmpList =  this.LinkedEmployeesList ;
    },
    methods: {

        guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        },
    },
    
}
</script>

<style lang="scss" scoped>

.tools-view
{
    margin-top: 5px;
    color:#768ba3;
    margin-left: 0px;
    border: 1px solid #7c8c9f !important;
    background: #e6eff9  !important;
	padding: 5px 10px;
    display: inline-block;
    border-radius: 5px;
    font-weight: bold;
    float: left;
    margin-right: 2%;
}
 .cross-mark{
        padding: 0px 5px;
        border-radius: 100%;
        cursor: pointer;
  }
  .cross-mark:hover{
        // border: 1px solid #4A90E2 !important;
        background:  #c2c2c2;
        padding: 0px 5px;
        border-radius: 100%;
  }
.circle {
  background-color: #0da8e4;
  border-radius: 50%;
  display: inline;
  padding:1px 7px;
  border:2px solid #0da8e4;
  margin-left: 4px;
  position:sticky;
  color: white;
  font-weight: bold;
}
.linkedEmp_border{
    border: 1px solid #7c8c9f !important;
    padding:6px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/LinkedEmployees.vue